module.exports = __webpack_public_path__ + "assets/01.50f2d039.pdf";